import Overview from './overview.vue';
import Full from './full.vue';
import MobOverview from './mob-overview.vue';
import MobFull from './mob-full.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/announcement/context';
import { SZ000157_MARKET_SOURCE } from '@rebuild/hooks/data/useCoreData';

export function useSelfContext() {
	const findFullCode = () => {
		return SZ000157_MARKET_SOURCE.find(item => item.market.toUpperCase() === 'SZ')?.fullCode;
	};
	provideCurrentContext({
		forceFullCode: findFullCode()
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(Full, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
